<template>
  <div class="zujianview" v-if="dialogVisible">
    <div class="header">
      <span @click="closeDialog"><i class="el-icon-back"></i> 返回</span>
      <strong class="zujiantitle">{{ title }}</strong>
    </div>
    <div class="zujiancontent">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "PopupFrame",
  props: {
    dialogVisible: {
      type: Boolean,
      required: true,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
  },
  methods: {
    // 关闭弹窗
    closeDialog() {
      this.$emit("update:dialogVisible", false);
      this.$emit("dialogVisibles", false);
    },
  },
};
</script>

<style scoped>
.zujianview {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ffffff;
  /* color: #fff; */
  z-index: 11;
}

.header {
  z-index: 9;
  background-color: #fff;
  height: 40px;
  border-bottom: #6972a123 1px solid;
  line-height: 40px;
  text-align: center;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
}

.header span {
  cursor: pointer;
  position: absolute;
  left: 10px;
}

.zujiancontent {
  padding: 40px 30px 90px 30px;
  margin-top: 30px;
  height: 100vh;
  overflow-y: auto;
}

.zujiantitle {
  display: inline-block;
  margin: 0 auto;
}
</style>
